import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Bell = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M10.5 19.3125C10.5953 19.637 10.7931 19.9219 11.0638 20.1246C11.3346 20.3273 11.6637 20.4369 12.0019 20.4369C12.3401 20.4369 12.6692 20.3273 12.9399 20.1246C13.2107 19.9219 13.4085 19.637 13.5038 19.3125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.25V3.5625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.25C13.4918 5.25 14.9226 5.84263 15.9775 6.89752C17.0324 7.95242 17.625 9.38316 17.625 10.875C17.625 16.1595 18.75 17.0625 18.75 17.0625H5.25C5.25 17.0625 6.375 15.6255 6.375 10.875C6.375 9.38316 6.96763 7.95242 8.02252 6.89752C9.07742 5.84263 10.5082 5.25 12 5.25V5.25Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
